import { Box, Stack, TextField, Typography } from "@mui/material";
import { getIn, useFormikContext } from "formik";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import { AddSolutionFormValues } from "../../../add/form/types";
import { EditSolutionFormValues } from "../../../edit/form/types";

const benefitFields = [
  {
    pillar: "carbon",
    label: "Carbon",
    quantityPath: "pillars.carbon.benefits.quantity",
    descriptionPath: "pillars.carbon.benefits.description",
  },
  {
    pillar: "biodiversity",
    label: "Biodiversity",
    quantityPath: "pillars.biodiversity.benefits.quantity",
    descriptionPath: "pillars.biodiversity.benefits.description",
  },
  {
    pillar: "people",
    label: "People",
    quantityPath: "pillars.people.benefits.quantity",
    descriptionPath: "pillars.people.benefits.description",
  },
] as const;

function BenefitsContainer({ open }: { open: boolean }) {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  return (
    <Box data-testid="writeable-benefits-container">
      <SectionCollapsible open={open} label="Benefits">
        <Stack direction={"column"} spacing={3} sx={{ mr: 6 }}>
          {benefitFields.map(
            ({ pillar, label, quantityPath, descriptionPath }) => {
              const quantityError = getIn(context.errors, quantityPath) as
                string | undefined;
              const quantityTouched = getIn(context.touched, quantityPath) as
                boolean | undefined;
              const descriptionError = getIn(
                context.errors,
                descriptionPath,
              ) as string | undefined;
              const descriptionTouched = getIn(
                context.touched,
                descriptionPath,
              ) as boolean | undefined;

              return (
                <Stack
                  direction="row"
                  key={pillar}
                  spacing={5}
                  sx={{ flex: 1, minWidth: 0, alignItems: "baseline" }}
                >
                  <Typography sx={{ minWidth: "80px" }} variant="subtitle1">
                    {label}
                  </Typography>
                  <TextField
                    id={`solution-${pillar}-benefit-quantity`}
                    label={`${label} quantity`}
                    name={quantityPath}
                    variant="standard"
                    sx={{ width: "50%" }}
                    autoComplete="disabled"
                    onBlur={context.handleBlur}
                    onChange={context.handleChange}
                    value={
                      (getIn(context.values, quantityPath) as string) ?? ""
                    }
                    error={Boolean(quantityTouched && quantityError)}
                    helperText={quantityTouched && quantityError}
                  />
                  <TextField
                    id={`solution-${pillar}-benefit-description`}
                    label={`${label} description`}
                    name={descriptionPath}
                    variant="standard"
                    fullWidth
                    multiline
                    autoComplete="disabled"
                    onBlur={context.handleBlur}
                    onChange={context.handleChange}
                    value={
                      (getIn(context.values, descriptionPath) as string) ?? ""
                    }
                    error={Boolean(descriptionTouched && descriptionError)}
                    helperText={descriptionTouched && descriptionError}
                  />
                </Stack>
              );
            },
          )}
        </Stack>
      </SectionCollapsible>
    </Box>
  );
}

export default BenefitsContainer;
